import Swiper from "swiper/bundle";
// import {Navigation, Pagination, Keyboard, Autoplay, EffectCube} from "swiper/modules";

new Swiper(".headerSlider", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }, pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    keyboard: true,
    autoplay: true,
});

new Swiper(".js-header-slider-mobile", {
    navigation: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    autoplay: true,
});

let swiper2 = new Swiper('.bestSuggestionsSlider', {
    slidesPerView: 7,
    spaceBetween: 3,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        120: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 4,
        },
        1024: {
            slidesPerView: 5,
        },
        1200: {
            slidesPerView: 6,
        },
    },
});

let swiper3 = new Swiper('.storySlider', {
    // modules: [Navigation, Pagination, EffectCube],
    effect: "cube",
    grabCursor: true,
    cubeEffect: {
        shadow: true,
        slideShadows: true,
        shadowOffset: 20,
        shadowScale: 0.94,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    },
});

let swiper5 = new Swiper('.brandsSlider', {
    slidesPerView: 7,
    spaceBetween: 3,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }, breakpoints: {
        120: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 4,
        },
        1024: {
            slidesPerView: 6,
        },
        1200: {
            slidesPerView: 7,
        },
    }
});
let swiper6 = new Swiper('.bestSales', {
    slidesPerView: 7,
    spaceBetween: 20,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }, breakpoints: {
        120: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    }
});

new Swiper('.similarSlider', {
    slidesPerView: 7,
    spaceBetween: 3,
    breakpoints: {
        120: {
            slidesPerView: 1,
        },
        310: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        1399: {
            slidesPerView: 5,
        },
        1400: {
            slidesPerView: 6,
        },
    }, navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
})